export const featureFlags = {
  showContactPage: true, // Set to true when Contact page is ready
} as const;

